import {Injectable} from '@angular/core';
import {AppConfigService} from "projects/nter-ui-kit/src/lib/framework/config/app-config.service";
import {environment} from "@env/environment";


@Injectable({
  providedIn: 'root'
})
export class AdminPortalAppConfigService extends AppConfigService {

  constructor() {
    super(environment);
  }
}
